module.exports = __webpack_public_path__ + "img/character-1.dd87149c.png";